import Alert from '@storeblocks/alert';
import React from 'react';

import { getAppText } from 'Utils/text';
import { AlertContainer } from '../cancelForm.styles';

interface EmailCancellationAlertsProps {
  submitSuccess: boolean;
  submitError: boolean;
}

export const EmailCancellationAlerts = ({
  submitError,
  submitSuccess,
}: EmailCancellationAlertsProps) => {
  return (
    <>
      {submitSuccess && (
        <AlertContainer>
          <Alert
            variant="success"
            title={getAppText(
              'cancelInsurance.alert.manualMessage.submitSuccess',
            )}
          />
        </AlertContainer>
      )}
      {submitError && (
        <AlertContainer>
          <Alert
            variant="error"
            title={getAppText('cancelInsurance.alert.submitError')}
          />
        </AlertContainer>
      )}
    </>
  );
};
